const urlPattern =
  "(https?:\\/\\/)((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+@]*)*(\\?[;&a-z\\d%_.~+=-@]*)?(\\#[-a-z\\/\\d_@]*)?$";
const regexp = new RegExp(urlPattern, "i");

export const validate = (
  message = "muss eine gültige url sein (Bsp.: https://www.example.com/)"
) => (value: string) => !value || regexp.test(value) || message;
